(function () {
  var toggle = document.querySelector('.navtoggle');
  var list = document.getElementById('NavList');
  if (toggle && list) {
    toggle.addEventListener('click', function () {
      var open = list.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Variant ladder on the product page
  var opts = document.querySelectorAll('.opt[data-variant]');
  if (opts.length) {
    var input = document.getElementById('VariantId');
    var priceEl = document.querySelector('[data-live-price]');
    var stickyPrice = document.querySelector('.stickybuy .amt');
    var pick = function (el) {
      opts.forEach(function (o) { o.setAttribute('data-on', o === el ? '1' : '0'); });
      if (input) input.value = el.getAttribute('data-variant');
      var p = el.getAttribute('data-price');
      if (priceEl && p) priceEl.textContent = p;
      if (stickyPrice && p) stickyPrice.textContent = p;
    };
    opts.forEach(function (el) {
      el.addEventListener('click', function () { pick(el); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(el); }
      });
    });
  }

  // Product gallery thumbnails
  var main = document.querySelector('[data-gallery-main]');
  if (main) {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src) main.setAttribute('src', src);
      });
    });
  }
})();
